import { gql } from "@apollo/client";







export const UPDATE_ASSIGNED_SHIFT = gql`
  mutation UpdateAssignedShift($input: updateAssignedShiftInput) {
    updateAssignedShift(input: $input)
  }
`;
